<section *ngIf="!isMobile" (mouseenter)="mouseHoverEvent($event)" (mouseleave)="mouseHoverEvent($event)">
    <div class="nav-menu-items">
        <a (click)="closeMobileMenu()" class="nav-menu-item">
            <ng-container *ngIf="isActiveAccountLinked; else notLinked">
                <p *ngIf="!isOrionTenant && activeLinkedAccount?.account"><span class="strong">Account # {{activeLinkedAccount.account}}</span></p>
                <p class="account-address" *ngIf="activeLinkedAccount?.address">{{ activeLinkedAccount.address | truncate:25 }}</p>
            </ng-container>
            <ng-template #notLinked>
                <div class="account-info" *ngIf="!isActiveAccountLinked">
                    <p *ngIf="!isOrionTenant && account?.cableAccountNumber"><span>Account # {{account.cableAccountNumber}}</span></p>
                    <p class="account-address" *ngIf="serviceAddress?.address1">{{ getFullAddress | truncate:25 }}</p>
                    <div class="tool-tip" *ngIf="!linkedAccountWithActive?.length">
                        <p *ngIf="!isOrionTenant" class="account-no">Account <span>#{{account.cableAccountNumber}}</span></p>
                        <p>{{ serviceAddress.address1 }}</p>
                        <p *ngIf="serviceAddress?.address2">{{ serviceAddress.address2 }}</p>
                        <p>{{ serviceAddress.city }}, {{ serviceAddress.state }} {{ serviceAddress.zip }}</p>
                    </div>
                </div>
            </ng-template>
        </a>
        <button class="caret-icon-container" (click)="expandChildItems()" [attr.aria-expanded]="showChildItems" *ngIf="isActiveAccountLinked">
            <xm-media-image [imageOptions]="caretIcon" aria-hidden="true" size="height" class="caret-icon" [ngClass]="{ 'caret-hovered': showChildItems }"></xm-media-image>
        </button>
        <ul class="child-items" [ngClass]="{ 'show-child-items': showChildItems }">
            <ng-container *ngFor="let account of linkedAccountWithActive">
                <li>
                    <div class="child-list">
                        <xm-media-image *ngIf="showCheckMarkIcon(account?.accountGuid, account?.account, activeLinkedAccount?.accountGuid); else desktopPlaceholder" class="checkmark-icon" aria-hidden="true" [imageOptions]="checkmarkIcon" size="height"></xm-media-image>
                        <ng-template #desktopPlaceholder><span class="checkmark-icon-placeholder"></span></ng-template>
                        <a (click)="onMenuSelect(account?.accountGuid, account?.account, account?.isOrion)" class="child-item">
                            <p *ngIf="account?.address">{{ account.address }} </p>
                            <p class="sub-item" *ngIf="account?.cityStateZip">{{ account.cityStateZip }} </p>
                            <p class="sub-item" *ngIf="account?.name">{{ account.name }} </p>
                            <p class="sub-item" *ngIf="account?.account">#{{ account.account }} </p>
                        </a>
                    </div>
                </li>
            </ng-container>
            <li *ngIf="linkedAccounts?.length > ACCOUNTS_PREVIEW_LIMIT" class="view-all-item">
                <button class="view-all-btn" (click)="onSelectViewAll()">View all</button>
            </li>
        </ul>
    </div>
</section>
<section class="nav-mobile-menu" *ngIf="isMobile">
    <div class="nav-mobile-menu-container">
        <ul class="account-item">
            <ng-container *ngFor="let account of linkedAccountWithActive">
                <li class="nav-mobile-menu-list">
                    <xm-media-image *ngIf="showCheckMarkIcon(account?.accountGuid, account?.account, activeLinkedAccount?.accountGuid); else mobilePlaceholder" class="checkmark-icon" aria-hidden="true" [imageOptions]="checkmarkIcon" size="height"></xm-media-image>
                    <ng-template #mobilePlaceholder><span class="checkmark-icon-placeholder"></span></ng-template>
                    <a (click)="onMenuSelect(account?.accountGuid, account?.account, account?.isOrion)" class="nav-mobile-menu-item">
                        <p *ngIf="account?.address">{{ account.address }} </p>
                        <p class="sub-item" *ngIf="account?.cityStateZip">{{ account.cityStateZip }} </p>
                        <p class="sub-item" *ngIf="account?.name">{{ account.name }} </p>
                        <p class="sub-item" *ngIf="account?.account">#{{ account.account }} </p>
                    </a>
                </li>
            </ng-container>
            <li *ngIf="linkedAccounts?.length > ACCOUNTS_PREVIEW_LIMIT" class="view-all-mobile-item">
                <button class="view-all-btn" (click)="onSelectViewAll()">View all</button>
            </li>
        </ul>
    </div>
</section>
